const wind = [
  {
    level: 0,
    speedRang: '0.0-0.2',
    name: '无风',
    desc: '烟直上，感觉没风'
  },
  {
    level: 1,
    speedRang: '0.3-1.5',
    name: '软风',
    desc: '烟示风向'
  },
  {
    level: 2,
    speedRang: '1.6-3.3',
    name: '轻风',
    desc: '感觉有风'
  },
  {
    level: 3,
    speedRang: '3.4-5.4',
    name: '微风',
    desc: '旌旗展开'
  },
  {
    level: 4,
    speedRang: '5.5-7.9',
    name: '和风',
    desc: '吹起尘土'
  },
  {
    level: 5,
    speedRang: '8.0-10.7',
    name: '清风',
    desc: '小树摇摆'
  },
  {
    level: 6,
    speedRang: '10.8-13.8',
    name: '强风',
    desc: '电线有声'
  },
  {
    level: 7,
    speedRang: '13.9-17.1',
    name: '劲风',
    desc: '步行困难'
  },
  {
    level: 8,
    speedRang: '17.2-20.7',
    name: '大风',
    desc: '折毁树枝'
  },
  {
    level: 9,
    speedRang: '20.8-24.4',
    name: '烈风',
    desc: '小损房屋'
  },
  {
    level: 10,
    speedRang: '24.5-28.4',
    name: '狂风',
    desc: '拔起树木'
  },
  {
    level: 11,
    speedRang: '28.5-32.6',
    name: '暴风',
    desc: '损毁重大'
  },
  {
    level: 12,
    speedRang: '32.7-36.9',
    name: '台风',
    desc: '摧毁极大'
  },
  {
    level: 13,
    speedRang: '37.0-41.4',
    name: '台风',
    desc: ''
  },
  {
    level: 14,
    speedRang: '41.5-46.1',
    name: '强台',
    desc: ''
  },
  {
    level: 15,
    speedRang: '46.2-50.9',
    name: '强台+',
    desc: ''
  },
  {
    level: 16,
    speedRang: '51.0-56.0',
    name: '超强台风',
    desc: ''
  }
]
export default wind
